/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { AdminService } from "src/services/AdminService";
import { Button, Col, Row, Alert } from "reactstrap";

import {
  iClinicProfile,
  iCommunityProfile,
  iPractitionerProfile,
  validateClinicFormValues,
  validatePractitionerFormValues,
  validateCommunityFormValues,
} from "ps-shared";
import { Link, navigate } from "gatsby";
import Loading from "src/components/General/Loading";

interface PublishProfileProps {
  profile: iClinicProfile | iCommunityProfile | iPractitionerProfile;
  forceEditCb: () => void;
}
// tslint:disable-next-line:no-empty-interface
interface PublishProfileState {
  isSubmitting: boolean;
  isPublishable: boolean;
  isValidating: boolean;
  publishError: string;
}

export default class PublishProfile extends React.Component<PublishProfileProps, PublishProfileState> {
  constructor(props: PublishProfileProps) {
    super(props);
    this.publish = this.publish.bind(this);
    this.preview = this.preview.bind(this);
    this.state = {
      isSubmitting: false,
      isPublishable: false,
      isValidating: true,
      publishError: null,
    };
    this.checkIfIsPublishible = this.checkIfIsPublishible.bind(this);
  }

  public componentDidMount() {
    this.checkIfIsPublishible();
  }

  public async checkIfIsPublishible() {
    let isPublishable = false;
    let validationErrors = [];
    switch (this.props.profile.profileType) {
      case "practitioner":
        validationErrors = await validatePractitionerFormValues(this.props.profile);
        break;
      case "clinic":
        validationErrors = await validateClinicFormValues(this.props.profile);
        break;
      case "community":
        validationErrors = await validateCommunityFormValues(this.props.profile);
        break;
      default:
        break;
    }
    isPublishable = !validationErrors.length;
    this.setState({
      isPublishable,
      isValidating: false,
    });
  }

  public publish() {
    this.setState({
      isSubmitting: true,
      publishError: null,
    });
    AdminService.publishProfile(this.props.profile.slug)
      .then(() => {
        navigate("/my/profiles/");
      })
      .catch((error: any) => {
        console.error(error);

        this.setState({
          isSubmitting: false,
          publishError: error.message,
        });
      });
  }

  public preview() {
    navigate(`/my/profiles/${this.props.profile.slug}/preview/`, this.props.profile as any);
  }

  // tslint:disable:max-line-length
  public render() {
    return (
      <div>
        <Row>
          <Col>
            <h4 className="cta fw500">Edit Profile</h4>
          </Col>
        </Row>
        {this.state.isValidating && <Loading />}
        {this.state.isValidating === false && (
          <>
            <Row className="mt-3">
              <Col xs="12">
                {this.state.isPublishable && <div>Are you ready to publish your profile?</div>}
                {!this.state.isPublishable && (
                  <div>
                    Good start! Looks like you're not quite ready to publish, you can preview your progress or keep
                    editing:
                  </div>
                )}
                {this.state.publishError && (
                  <Alert className="mt-2" color={"danger"}>
                    Oops! there was an error publishing: {this.state.publishError}
                  </Alert>
                )}
              </Col>
            </Row>
            <Row className="mt-3">
              <Col xs="12">
                <Button
                  type="button"
                  color="primary"
                  className="me-1"
                  onClick={this.preview}
                  disabled={this.state.isSubmitting}
                >
                  Preview
                </Button>
                <Button
                  type="button"
                  color="secondary"
                  className="me-1"
                  onClick={this.props.forceEditCb}
                  disabled={this.state.isSubmitting}
                >
                  Keep Editing
                </Button>
                <Button
                  type="button"
                  color="secondary"
                  className="me-1"
                  onClick={this.publish}
                  disabled={this.state.isSubmitting || this.state.isPublishable === false}
                >
                  Publish
                </Button>
              </Col>
            </Row>
            <Row className="mt-4">
              <Col>
                <Link to="/my/profiles/">Back to Manage Profiles</Link>
              </Col>
            </Row>
          </>
        )}
      </div>
    );
  }
}
